import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {
  
  constructor( private auth : AuthService, private router: Router ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if(state.url == '/users' && this.auth.can('get-users')) {
      return true;
    } else if(state.url == '/auth' && this.auth.can('authorization') && this.auth.can('get-users')) {
      return true;
    } else if(state.url == '/auth/models' && this.auth.can('authorization')) {
      return true;
    } else if(state.url == '/auth/models/assign' && this.auth.can('authorization')) {
      return true;
    } else if(state.url == '/customers' && this.auth.can('get-customers')) {
      return true;
    } else if(state.url == '/suppliers' && this.auth.can('get-suppliers')){  
      return true;
    } else if(state.url == '/expenses' && this.auth.can('get-expenses')) {
      return true;
    } else if(state.url == '/expenses/extra' && this.auth.can('get-extra-expenses')) {
      return true;
    } else if(state.url == '/expenses/extra/jobs' && this.auth.can('get-extra-expenses-job')) {
      return true;
    } else if(state.url == '/expense/tollbooth' && this.auth.can('update-tollbooth')){
      return true;
    } else if(state.url == '/products' && this.auth.can('get-products')) {
      return true;
    } else if(state.url == '/articles' && this.auth.can('get-articles')) {
      return true;
    } else if(state.url == '/drivers' && this.auth.can('get-drivers')) {
      return true;
    } else if(state.url == '/orders' && this.auth.can('get-orders')) {
      return true;
    } else if(state.url == '/order/create' && this.auth.can('store-order')) {
      return true;
    } else if(state.url.substr(0, 7) == '/order/' && this.auth.can('get-orders')) {
      return true;
    } else if(state.url.substr(0, 11) == '/order/edit' && this.auth.can('update-order')) {
      return true;
    } else if(state.url == '/unities/set' && (this.auth.isExactly("machinery") || this.auth.isExactly('staff'))) {
      this.router.navigate(['/error/no-access']);
      return false;
    } else if((state.url.substr(0, 6) == '/unity' || state.url.substr(0, 8) == '/unities' || state.url.substr(0, 11) == '/contrators') && this.auth.can('get-unities')) {
      return true;
    } else if(state.url == '/routes' && this.auth.can('get-routes')) {
      return true;
    } else if(state.url == '/route/create' && this.auth.can('store-route')) {
      return true;
    } else if(state.url.substring(0, 11) == '/route/edit' && this.auth.can('update-route')) {
      return true;
    } else if(state.url == '/travels' && this.auth.can('get-travels')) {
      return true;
    } else if(state.url == '/travel/create' && this.auth.can('store-travel')) {
      return true;
    } else if(state.url == '/travel/create-particular' && this.auth.can('store-travel-part')) {
      return true;
    } else if(state.url == '/travel/gasticket/emmit' && this.auth.can('emmit-gas')) {
      return true;
    } else if(state.url == '/unities/gasticket/emmit' && this.auth.can('emmit-gas')) {
      return true;
    } else if(state.url == '/unities/service' && this.auth.can('unit-service-admin')) {
      return true;
    } else if(state.url == '/unities/service-calendar' && this.auth.can('unit-service-calendar')) {
      return true;
    } else if(state.url == '/unities/verification' && this.auth.can('unit-verification')) {
      return true;
    } else if(state.url == '/utilitarian/control' && this.auth.can('unit-service')) {
      return true;
    } else if(state.url.substr(0, 18) == '/travel/gasticket/' && this.auth.can('store-travel')) {
      return true;
    } else if(state.url.substr(0, 19) == '/travel/gasticket2/' && this.auth.can('store-travel')) {
      return true;
    } else if(state.url == '/travel/calendar' && this.auth.can('get-orders')) {
      return true;
    } else if(state.url == '/travel/loads-calendar' && this.auth.can('get-loads-orders')) {
      return true;
    } else if(state.url == '/travel/contracted' && this.auth.can('store-contracted-invoice')) {
      return true;
    } else if(state.url == '/travel/expenses/paysheet' && this.auth.can('store-paysheet-expenses')) {
      return true;
    } else if(state.url.substr(0, 9) == '/travels/' && this.auth.can('get-travels')) {
      return true;
    } else if(state.url.substr(0, 13) == '/travel/edit/' && this.auth.can('update-travel')) {
      return true;
    } else if(state.url == '/paysheet' && this.auth.can('get-paysheets')) {
      return true;
    } else if(state.url == '/paysheet/base' && this.auth.can('get-paysheets')) {
      return true;
    } else if(state.url == '/maintenance' && this.auth.can('get-maintenances')) {
      return true;
    } else if(state.url == '/maintenance/create' && this.auth.can('store-maintenance')) {
      return true;
    } else if(state.url == '/maintenance/order' && this.auth.can('get-maintenance-orders')) {
      return true;
    } else if(state.url == '/maintenance/order/create' && this.auth.can('store-maintenance-order')) {
      return true;
    } else if(state.url.substr(0, 19) == '/maintenance/order/' && this.auth.can('get-maintenances')) {
      return true;
    } else if(state.url == '/maintenance/expense' && this.auth.can('get-maintenance-orders')) {
      return true;
    } else if(state.url == '/maintenance/expense/create' && this.auth.can('store-maintenance-order')) {
      return true;
    } else if(state.url == '/marketprice' && this.auth.can('get-market-prices')) {
      return true;
    } else if(state.url == '/reports/gas' && this.auth.can('get-report-gas')) {
      return true;
    } else if(state.url == '/reports/gas/pending' && this.auth.can('get-report-gas')) {
      return true;
    } else if(state.url == '/reports/gas/all' && this.auth.can('get-report-gas')) {
      return true;
    } else if(state.url == '/reports/maintenance' && this.auth.can('get-report-maintenance')) {
      return true;
    } else if(state.url == '/reports/km' && this.auth.can('get-report-unity-km')) {
      return true;
    } else if(state.url == '/reports/extraexpense' && this.auth.can('get-report-extra-expense')) {
      return true;
    } else if(state.url == '/reports/paysheet' && this.auth.can('get-report-paysheet')) {
      return true;
    } else if(state.url == '/reports/travel/paysheet' && this.auth.can('get-report-paysheet')) {
      return true;
    } else if(state.url == '/reports/total/expenses' && this.auth.can('get-report-total-expenses')) {
      return true;
    } else if(state.url == '/reports/purchase-order' && this.auth.can('get-report-purchase-orders')) {
      return true;
    } else if(state.url == '/reports/entry' && this.auth.can('get-report-entries')) {
      return true;
    } else if(state.url == '/reports/total/dashboard' && this.auth.can('get-report-total-expenses')) {
      return true;
    } else if(state.url == '/reports/total/dashboard/maintenance' && this.auth.can('get-report-maintenance')) {
      return true;
    } else if(state.url == '/reports/unities/costs' && this.auth.can('get-report-unities')) {
      return true;
    } else if(state.url == '/reports/unities/services' && this.auth.can('unit-service-admin')) {
      return true;
    } else if(state.url == '/reports/unities' && this.auth.can('get-report-unities')) {
      return true;
    } else if(state.url == '/reports/proeco' && this.auth.can('get-report-proeco')) {
      return true;
    } else if(state.url == '/reports/proeco/all' && this.auth.can('get-report-proeco')) {
      return true;
    } else if(state.url == '/reports/binnacle' && this.auth.can('get-report-binnacle')) {
      return true;
    } else if(state.url == '/receipt' && this.auth.can('update-paysheet')) {
      return true;
    } else if(state.url == '/purchases/requisition/create' && this.auth.can('store-requisition')) {
      return true;
    } else if(state.url.substr(0, 22) == '/purchases/requisition' && this.auth.can('get-requisitions')) {
      return true;
    } else if(state.url == '/purchases/order/create' && this.auth.can('store-purchase-order')) {
      return true;
    } else if(state.url.substr(0, 16) == '/purchases/order' && this.auth.can('get-purchase-orders')) {
      return true;
    } else if(state.url == '/purchases/entry/create' && this.auth.can('store-entry')) {
      return true;
    } else if(state.url == '/document/notifications' && this.auth.can('get-document-notifications')) {
      return true;
    } else if(state.url.substr(0, 16) == '/purchases/entry' && this.auth.can('get-entries')) {
      return true;
    } else if(state.url.substr(0, 17) == '/purchases/output' && (this.auth.can('authorize-entry') || this.auth.can('deliver-entry'))) {
      return true;
    } else if(state.url == '/warehouse' && this.auth.can('get-warehouses')) {
      return true;
    } else if(state.url == '/warehouse/history' && this.auth.can('get-warehouses')) {
      return true;
    } else if(state.url == '/travel/schedule'){
      return true;
    } else if(state.url == '/reports/purchase-order-sap' && this.auth.can('get-report-purchase-orders')) {
      return true;
    } else if(state.url == '/reports/entry-sap' && this.auth.can('get-report-entries')) {
      return true;
    } else if(state.url == '/invoice-ticket' && this.auth.can('get-market-prices')){
      return true;
    } else if(state.url == '/internal-travel/create-document' && this.auth.can('store-commercial-documents-internal-travel')){
      return true;
    }else if(state.url == '/commercial-documents' && this.auth.can('store-commercial-documents-internal-travel')){
      return true;
    }else if(state.url == '/supports/travels' && this.auth.can('platform-support')){
      return true;
    }else if(state.url == '/travel/travel-routes' && this.auth.can('get-travels')){
      return true;
    }else if(state.url == '/expense-type' && this.auth.can('get-expenses')){
      return true;
    }else {
      this.router.navigate(['/error/no-access']);
      return false;
    }
  }
}
